import React, { useEffect, useState } from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import "./Form.css";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Button from "@mui/material/Button";
import Swal from "sweetalert2";
import axios from "axios";
import ModalTerminos from "../modalTerminos/ModalTerminos";
import ModalValidation from "../modalValidation/ModalValidation";
import validarMonto from "../monto/Monto";
import validarEmail from "../comparar/Comparar";
import validarNombre from "../nombre/Nombre";
import validarDomicilio from "../longitud/Longitud";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import logoURPBLANCO from "../../img/URP_BLANCO.png";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";

const Form = () => {
  const [load, setLoad] = useState(false);
  const [sendValidation, setSendValidation] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [checkboxConditional, setCheckboxConditional] = useState(false);
  const [validationStep01, setValidationStep01] = useState(false);
  const [validationStep02, setValidationStep02] = useState(false);
  const [validationStep03, setValidationStep03] = useState(false);
  const [age, setAge] = useState("");
  const [reclamo, setReclamo] = useState("");
  const [saveData, setSaveData] = useState([]);
  const valido = validarEmail();
  const validar = validarNombre();
  const [openValid, setOpenValid] = useState(false);
  const [saveDataOne, setSaveDataOne] = useState({
    tipoPersona: "",
    tipoDocumento: "",
    documento: "",
    nombre: "",
    apellidoPaterno: "",
    apellidoMaterno: "",
    domicilio: "",
    telefono: "",
    correo: "",
    nombreApoderado: "",
    celularApoderado: "",
    correoApoderado: "",
  });

  const {
    tipoPersona,
    tipoDocumento,
    documento,
    nombre,
    apellidoPaterno,
    apellidoMaterno,
    domicilio,
    telefono,
    correo,
    nombreApoderado,
    celularApoderado,
    correoApoderado,
  } = saveDataOne;

  const handleChangeDataInput = (e) => {
    setSaveDataOne({ ...saveDataOne, [e.target.name]: e.target.value });
  };

  const [saveDataTwo, setSaveDataTwo] = useState({
    bien2: "",
    monto2: "",
    descripcion2: "",
    local2: "",
    programa2: "",
  });

  const { bien2, monto2, descripcion2, local2, programa2 } = saveDataTwo;

  const handleChangeDataInput2 = (e) => {
    setSaveDataTwo({ ...saveDataTwo, [e.target.name]: e.target.value });
  };

  const [saveDataThree, setSaveDataThree] = useState({
    reclamo3: "",
    queja3: "",
    detalle3: "",
    pedido3: "",
  });

  const { reclamo3, queja3, detalle3, pedido3 } = saveDataThree;

  const handleChangeDataInput3 = (e) => {
    setSaveDataThree({ ...saveDataThree, [e.target.name]: e.target.value });
  };

  const año = new Date().getFullYear();
  const mes = (new Date().getMonth() + 1).toString().padStart(2, "0");
  const dia = new Date().getDate().toString().padStart(2, "0");

  const fechaActual = `${año}-${mes}-${dia}`;

  const steps = [
    "Identificación del Consumidor Reclamante",
    "Identificación del Bien Contratado",
    "Detalle de la Reclamación",
  ];

  const busqueda = async () => {
    const url = `${process.env.REACT_APP_URL}formulario/seguimiento_respuesta`;

    const header = {
      "Content-Type": "application/json",
    };

    const body = JSON.stringify({
      codigo: reclamo,
    });

    const { data } = await axios(url, {
      method: "POST",
      headers: header,
      data: body,
    });

    setSaveData(data);
    // console.log(data);
  };

  const reclamacion = async () => {
    const url = `${process.env.REACT_APP_URL}formulario/genera_reclamos_sqlserver`;

    const header = {
      "Content-Type": "application/json",
    };

    const body = JSON.stringify({});

    const { data } = await axios(url, {
      method: "POST",
      headers: header,
      data: body,
    });

    setSaveData(data);
  };

  useEffect(() => {
    reclamacion();
  }, []);

  const [activeStep, setActiveStep] = React.useState(0);
  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleReset = () => {
    setActiveStep(0);
    localStorage.clear();
    console.clear();
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const sendData = async () => {
    try {
      const url = `${process.env.REACT_APP_URL}formulario/genera_reclamos_sqlserver`;
      const header = {
        "Content-Type": "application/json",
      };

      const body = JSON.stringify({
        tipopersona: tipoPersona,
        tipodocumento: tipoDocumento,
        documento: documento,
        nombres: nombre,
        apellidoPA: apellidoPaterno,
        apellidoMA: apellidoMaterno,
        domicilio: domicilio,
        telefono: telefono,
        correo: correo,
        menoredad: age,
        nombreapo: age === "No" ? "" : nombreApoderado,
        telefapo: age === "No" ? "" : celularApoderado,
        correoapo: age === "No" ? "" : correoApoderado,
        bien: bien2,
        monto: monto2,
        descripcion: descripcion2,
        lugar: local2,
        programa: programa2,
        tiporeclama: reclamo3,
        tiporeclamo: queja3,
        detalle: detalle3,
        pedido: pedido3,
      });

      const { data } = await axios(url, {
        method: "POST",
        headers: header,
        data: body,
      });

      setLoad(false);
      toast.success(`Reclamo  ${data?.CLIRE_NRORECLAMO}`);
      setSendValidation(true);
      setTimeout(() => {
        window.location.reload();
      }, 4200);
    } catch (error) {
      let mensajeError;
      if (typeof error.response.data.message === "string") {
        let errores = JSON.parse(error.response.data.message).ERRORES;
        mensajeError = Object.values(errores)[0];
        console.log("string");
      } else {
        console.log("objeto");
        let errores = error.response.data.message.ERRORES;
        mensajeError = Object.values(errores)[0];
      }
      const mensajeErrorDef =
        "Disculpe los inconveniences Por favor comuníquese al correo mesadepartes.oficic@urp.edu.pe lo atenderemos lo antes posible";
      mensajeError
        ? Swal.fire(mensajeError, "", "error")
        : Swal.fire(mensajeErrorDef, "", "error");
      setTimeout(() => {
        setLoad(false);
      }, 1000);
    }
  };

  useEffect(() => {
    if (
      [
        tipoPersona,
        tipoDocumento,
        documento,
        nombre,
        apellidoPaterno,
        domicilio,
        telefono,
        correo,
      ].includes("")
    ) {
      setValidationStep01(true);
      return;
    } else if (tipoDocumento === "DNI" && documento?.length !== 8) {
      setValidationStep01(true);
      return;
    } else if (tipoDocumento === "Pasaporte" && documento?.length > 11) {
      setValidationStep01(true);
      return;
    } else if (
      tipoDocumento === "Carné de Extranjería" &&
      documento?.length > 11
    ) {
      setValidationStep01(true);
      return;
    } else if (validarNombre(nombre) === "errorNombre") {
      setValidationStep01(true);
      return;
    } else if (validarNombre(apellidoPaterno) === "errorNombre") {
      setValidationStep01(true);
      return;
    } else if (validarNombre(apellidoMaterno) === "errorNombre") {
      setValidationStep01(true);
      return;
    } else if (telefono?.length !== 9) {
      setValidationStep01(true);
      return;
    } else if (validarDomicilio(domicilio) === "errorDominio") {
      setValidationStep01(true);
      return;
    } else if (domicilio.trim() > 0) {
      setValidationStep01(true);
      return;
    } else if (validarEmail(correo) === "errorEmail") {
      setValidationStep01(true);
      return;
    } else if (age === "") {
      setValidationStep01(true);
      return;
    } else if (age === "Si" && nombreApoderado === "") {
      setValidationStep01(true);
      return;
    } else if (age === "Si" && celularApoderado === "") {
      setValidationStep01(true);
      return;
    } else if (age === "Si" && correoApoderado === "") {
      setValidationStep01(true);
      return;
    } else if (
      age === "Si" &&
      validarNombre(nombreApoderado) === "errorNombre"
    ) {
      setValidationStep01(true);
      return;
    } else if (age === "Si" && celularApoderado?.length !== 9) {
      setValidationStep01(true);
      return;
    } else if (age === "Si" && validarEmail(correoApoderado) === "errorEmail") {
      setValidationStep01(true);
      return;
    } else {
      setValidationStep01(false);
    }
  }, [
    tipoPersona,
    tipoDocumento,
    documento,
    nombre,
    apellidoPaterno,
    domicilio,
    telefono,
    correo,
    age,
    nombreApoderado,
    celularApoderado,
    correoApoderado,
  ]);

  useEffect(() => {
    if ([bien2, monto2, descripcion2, local2, programa2].includes("")) {
      setValidationStep02(true);
      return;
    } else if (validarMonto(monto2) === "errorDominio") {
      setValidationStep01(true);
      return;
    } else if (monto2?.length > 9) {
      setValidationStep02(true);
      return;
    } else if (descripcion2?.length > 4000) {
      setValidationStep02(true);
      return;
    } else {
      setValidationStep02(false);
    }
  }, [bien2, monto2, descripcion2, local2, programa2]);

  useEffect(() => {
    if ([reclamo3, queja3, detalle3, pedido3].includes("")) {
      setValidationStep03(true);
      return;
    } else if (detalle3?.length > 4000) {
      setValidationStep03(true);
      return;
    } else if (pedido3?.length > 4000) {
      setValidationStep03(true);
      return;
    } else {
      setValidationStep03(false);
    }
  }, [reclamo3, queja3, detalle3, pedido3]);

  const handleOnsubmit = (e) => {
    e.preventDefault();
    switch (activeStep) {
      case 0:
        if (
          [
            tipoPersona,
            tipoDocumento,
            documento,
            nombre,
            apellidoPaterno,
            domicilio,
            telefono,
            correo,
            age,
          ].includes("")
        ) {
          Swal.fire("Debes completar todos los campos 1!", "", "error");
        } else {
          handleNext();
        }
        break;
      case 1:
        if ([bien2, monto2, descripcion2, local2, programa2].includes("")) {
          Swal.fire("Debes completar todos los campos 2!", "", "error");
        } else {
          console.group("DATA - STEP 2");
          console.log(bien2);
          console.log(monto2);
          console.log(descripcion2);
          console.log(local2);
          console.log(programa2);
          console.groupEnd();
          handleNext();
        }
        break;
      case 2:
        if ([reclamo3, queja3, detalle3, pedido3].includes("")) {
          Swal.fire("Debes completar todos los campos 3!", "", "error");
        } else {
          console.group("DATA - STEP 3");
          console.log(reclamo3);
          console.log(queja3);
          console.log(detalle3);
          console.log(pedido3);
          console.groupEnd();
          handleNext();
        }
        break;
      default:
    }
  };

  const getContent = (step) => {
    switch (step) {
      case 0:
        return (
          <form>
            <div className="pt-6 grid md:grid-cols-2 lg:grid-cols-3 gap-4 items-baseline mb-4">
              <div>
                <label
                  htmlFor="name"
                  className=" text-gray-800 text-sm font-bold leading-tight tracking-normal"
                >
                  Tipo de Persona*
                </label>
                <select
                  id="name"
                  onChange={handleChangeDataInput}
                  value={tipoPersona}
                  name="tipoPersona"
                  className=" mt-2 text-gray-600 focus:outline-none focus:border focus:border-green-700 font-normal w-full h-10 flex items-center pl-3 text-sm border-gray-300 rounded border"
                  placeholder="Primer Nombre"
                  required
                >
                  <option value="" hidden>
                    Seleciona el Tipo de Persona
                  </option>
                  <option value="Alumno">Alumno</option>
                  <option value="Padre/Tutor">Padre/Tutor</option>
                  <option value="Visitante">Visitante</option>
                </select>
              </div>
              <div>
                <label
                  htmlFor="name"
                  className="text-gray-800 text-sm font-bold leading-tight tracking-normal"
                  name="tipodocumento"
                >
                  Tipo de Documento*
                </label>
                <select
                  id="name"
                  onChange={handleChangeDataInput}
                  onClick={() => {}}
                  value={tipoDocumento}
                  name="tipoDocumento"
                  className=" mt-2 text-gray-600 focus:outline-none focus:border focus:border-green-700 font-normal w-full h-10 flex items-center pl-3 text-sm border-gray-300 rounded border"
                  required
                >
                  <option value="" hidden>
                    Seleciona el Tipo
                  </option>
                  <option value="DNI">DNI</option>
                  <option value="Pasaporte">Pasaporte</option>
                  <option value="Carné de Extranjería">
                    Carné de Extranjería
                  </option>
                </select>
              </div>
              <div>
                <label htmlFor="name">&nbsp;</label>
                <div>
                  <input
                    id="name"
                    type="number"
                    onChange={handleChangeDataInput}
                    onWheel={(e) => e.target.blur()}
                    value={
                      documento?.length > 15
                        ? documento.slice(0, 15)
                        : documento
                    }
                    name="documento"
                    className={
                      tipoDocumento === "DNI"
                        ? documento?.length === 8 || documento?.length === 0
                          ? "mt-2  text-gray-600 focus:outline-none focus:border focus:border-green-700 font-normal w-full h-10 flex items-baseline pl-3 text-sm border-gray-300 rounded border"
                          : "input__validation  mt-2 text-gray-600 focus:outline-none focus:border focus:border-green-700 font-normal w-full h-10 flex items-baseline pl-3 text-sm border-gray-300 rounded border"
                        : tipoDocumento === "Pasaporte" ||
                          tipoDocumento === "Carné de Extranjería"
                        ? documento?.length <= 11 || documento?.length === 0
                          ? "mt-2 text-gray-600 focus:outline-none focus:border focus:border-green-700 font-normal w-full h-10 flex items-baseline pl-3 text-sm border-gray-300 rounded border"
                          : "input__validation  mt-2 text-gray-600 focus:outline-none focus:border focus:border-green-700 font-normal w-full h-10 flex items-baseline pl-3 text-sm border-gray-300 rounded border"
                        : documento?.length === 0
                        ? "mt-2 text-gray-600 focus:outline-none focus:border focus:border-green-700 font-normal w-full h-10 flex items-baseline pl-3 text-sm border-gray-300 rounded border"
                        : "input__validation  mt-2 text-gray-600 focus:outline-none focus:border focus:border-green-700 font-normal w-full h-10 flex items-baseline pl-3 text-sm border-gray-300 rounded border"
                    }
                    placeholder={
                      tipoDocumento
                        ? `Ingrese el número de ${tipoDocumento}`
                        : "Selecciona el tipo de documento"
                    }
                    required={true}
                  />
                </div>
                <div>
                  {tipoDocumento === "DNI" ? (
                    documento?.length === 8 ||
                    documento?.length === 0 ? null : (
                      <p className="mt-2 peer-invalid:visible text-red-700 font-light">
                        El DNI debe tener 8 caracteres
                      </p>
                    )
                  ) : tipoDocumento === "Pasaporte" ? (
                    documento?.length <= 11 ||
                    documento?.length === 0 ? null : (
                      <p className="mt-2 peer-invalid:visible text-red-700 font-light">
                        El Pasaporte debe tener máximo 11 caracteres
                      </p>
                    )
                  ) : tipoDocumento === "Carné de Extranjería" ? (
                    documento?.length <= 11 ||
                    documento?.length === 0 ? null : (
                      <p className="mt-2 peer-invalid:visible text-red-700 font-light">
                        El Carné de Extranjería debe tener máximo 11 caracteres
                      </p>
                    )
                  ) : documento?.length === 0 ? null : (
                    <p className="peer-invalid:visible text-red-700 font-light">
                      Selecciona el Tipo de Documento Previamente.
                    </p>
                  )}
                </div>
              </div>
            </div>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 items-baseline">
              <div>
                <div>
                  <label
                    htmlFor="name"
                    className="text-gray-800 text-sm font-bold leading-tight tracking-normal"
                  >
                    Nombres*
                  </label>
                  <input
                    id="name"
                    type="text"
                    onChange={handleChangeDataInput}
                    value={nombre}
                    maxLength="35"
                    name="nombre"
                    className={
                      nombre?.length === 0
                        ? " mt-2 text-gray-600 focus:outline-none focus:border focus:border-green-700 font-normal w-full h-10 flex items-center pl-3 text-sm border-gray-300 rounded border"
                        : validarNombre(nombre) === "errorNombre"
                        ? "input__validation  mt-2 text-gray-600 focus:outline-none focus:border focus:border-green-700 font-normal w-full h-10 flex items-center pl-3 text-sm border-gray-300 rounded border"
                        : " mt-2 text-gray-600 focus:outline-none focus:border focus:border-green-700 font-normal w-full h-10 flex items-center pl-3 text-sm border-gray-300 rounded border"
                    }
                    placeholder="Primero y Segundo"
                  />
                </div>
                <div className="justify-between gap-4">
                  {nombre?.length === 0 ? null : validarNombre(nombre) ===
                    "errorNombre" ? (
                    <p className="peer-invalid:visible text-red-700 font-light">
                      El nombre sólo puede contener letras, espacios y hasta 30
                      caracteres.Está utilizando: {`${nombre?.length}`}
                    </p>
                  ) : null}
                </div>
              </div>
              <div>
                <div>
                  <label
                    htmlFor="name"
                    className="text-gray-800 text-sm font-bold leading-tight tracking-normal"
                  >
                    Apellido Paterno*
                  </label>
                  <input
                    id="name"
                    onChange={handleChangeDataInput}
                    value={apellidoPaterno}
                    maxLength="35"
                    min="3"
                    name="apellidoPaterno"
                    type="text"
                    className={
                      apellidoPaterno?.length === 0
                        ? " mt-2 text-gray-600 focus:outline-none focus:border focus:border-green-700 font-normal w-full h-10 flex items-center pl-3 text-sm border-gray-300 rounded border"
                        : validarNombre(apellidoPaterno) === "errorNombre"
                        ? "input__validation mt-2 text-gray-600 focus:outline-none focus:border focus:border-green-700 font-normal w-full h-10 flex items-center pl-3 text-sm border-gray-300 rounded border"
                        : " mt-2 text-gray-600 focus:outline-none focus:border focus:border-green-700 font-normal w-full h-10 flex items-center pl-3 text-sm border-gray-300 rounded border"
                    }
                    placeholder="Paterno"
                  ></input>
                </div>
                <div>
                  {apellidoPaterno?.length === 0 ? null : validarNombre(
                      apellidoPaterno
                    ) === "errorNombre" ? (
                    <p className="peer-invalid:visible text-red-700 font-light">
                      El Apellido Paterno sólo puede contener letras, espacios y
                      hasta 30 caracteres.
                    </p>
                  ) : null}
                </div>
              </div>
              <div>
                <div className="inset-x-0 top-0">
                  <label
                    htmlFor="name"
                    className="text-gray-800 text-sm font-bold leading-tight tracking-normal inset-x-0 top-0"
                  >
                    Apellido Materno
                  </label>

                  <input
                    id="name"
                    onChange={handleChangeDataInput}
                    value={apellidoMaterno}
                    maxLength="35"
                    name="apellidoMaterno"
                    type="text"
                    className={
                      apellidoMaterno?.length === 0
                        ? " mt-2 text-gray-600 focus:outline-none focus:border focus:border-green-700 font-normal w-full h-10 flex items-center pl-3 text-sm border-gray-300 rounded border"
                        : validarNombre(apellidoMaterno) === "errorNombre"
                        ? "input__validation mt-2 text-gray-600 focus:outline-none focus:border focus:border-green-700 font-normal w-full h-10 flex items-center pl-3 text-sm border-gray-300 rounded border"
                        : " mt-2 text-gray-600 focus:outline-none focus:border focus:border-green-700 font-normal w-full h-10 flex items-center pl-3 text-sm border-gray-300 rounded border"
                    }
                    placeholder="Materno"
                  />
                </div>
                <div>
                  {apellidoMaterno?.length === 0 ? null : validarNombre(
                      apellidoMaterno
                    ) === "errorNombre" ? (
                    <p className="peer-invalid:visible text-red-700 font-light">
                      El Apellido Materno sólo puede contener, espacios y hasta
                      30 caracteres.
                    </p>
                  ) : null}
                </div>
              </div>
            </div>
            <div className="items-baseline my-3">
              <div>
                <label
                  htmlFor="name"
                  className="mt-4 text-gray-800 text-sm font-bold leading-tight tracking-normal"
                >
                  Domicilio*
                </label>
                <input
                  id="name"
                  onChange={handleChangeDataInput}
                  value={domicilio}
                  maxLength="155"
                  name="domicilio"
                  type="text"
                  className={
                    validarDomicilio(domicilio) === "aceptadoDominio"
                      ? " mt-2 text-gray-600 focus:outline-none focus:border focus:border-green-700 font-normal w-full h-10 flex items-center pl-3 text-sm border-gray-300 rounded border"
                      : "input__validation mt-2 text-gray-600 focus:outline-none focus:border focus:border-red-700 font-normal w-full h-10 flex items-center pl-3 text-sm border-gray-300 rounded border"
                  }
                  placeholder="Inserte su Dirección"
                />
              </div>
              <div>
                {validarDomicilio(domicilio) === "aceptadoDominio" ? null : (
                  <p className="peer-invalid:visible text-red-700 font-light">
                    Sólo puede utilizar: números, letras, puntos, comas,
                    hashtags y barras. El campo Domicilio no puede exceder los
                    150 caracteres, usted está utilizando:
                    {`${domicilio?.length}`} caracteres.
                  </p>
                )}
              </div>
            </div>
            <div className="grid  md:grid-cols-2 lg:grid-cols-3 gap-4 items-baseline">
              <div>
                <div>
                  <label
                    htmlFor="name"
                    className="text-gray-800 text-sm font-bold leading-tight tracking-normal"
                  >
                    Teléfono/Celular*
                  </label>
                  <input
                    id="name"
                    type="number"
                    onChange={handleChangeDataInput}
                    onWheel={(e) => e.target.blur()}
                    min="0"
                    value={
                      telefono?.length > 12 ? telefono.slice(0, 12) : telefono
                    }
                    name="telefono"
                    className={
                      telefono?.length === 9 || telefono?.length === 0
                        ? " mt-2 text-gray-600 focus:outline-none focus:border focus:border-green-700 font-normal w-full h-10 flex items-center pl-3 text-sm border-gray-300 rounded border"
                        : "input__validation  mt-2 text-gray-600 focus:outline-none focus:border focus:border-red-700 font-normal w-full h-10 flex items-center pl-3 text-sm border-gray-300 rounded border"
                    }
                    placeholder="Número"
                    required={true}
                  />
                </div>
                <div>
                  {telefono?.length === 9 || telefono?.length === 0 ? null : (
                    <p className="peer-invalid:visible text-red-700 font-light">
                      N° celular debe tener 9 caracteres
                    </p>
                  )}
                </div>
              </div>
              <div>
                <div>
                  <label
                    htmlFor="name"
                    className="text-gray-800 text-sm font-bold leading-tight tracking-normal"
                  >
                    Correo Electrónico*
                  </label>
                  <input
                    id="name"
                    onChange={handleChangeDataInput}
                    value={correo}
                    name="correo"
                    type="email"
                    className={
                      correo?.length === 0
                        ? " mt-2 text-gray-600 focus:outline-none focus:border focus:border-green-700 font-normal w-full h-10 flex items-center pl-3 text-sm border-gray-300 rounded border"
                        : validarEmail(correo) === "errorEmail"
                        ? "input__validation  mt-2 text-gray-600 focus:outline-none focus:border focus:border-green-700 font-normal w-full h-10 flex items-center pl-3 text-sm border-gray-300 rounded border"
                        : " mt-2 text-gray-600 focus:outline-none focus:border focus:border-green-700 font-normal w-full h-10 flex items-center pl-3 text-sm border-gray-300 rounded border"
                    }
                    placeholder="user@example.com"
                  />
                </div>
                <div>
                  {correo?.length === 0 ? null : validarEmail(correo) ===
                    "errorEmail" ? (
                    <p className="peer-invalid:visible text-red-700 font-light">
                      El correo sólo puede contener letras, números, puntos,
                      guiones y guión bajo.
                    </p>
                  ) : null}
                </div>
              </div>
              <div>
                <label
                  htmlFor="name"
                  className="text-gray-800 text-sm font-bold leading-tight tracking-normal"
                >
                  Menor de edad*
                </label>
                <select
                  id="name"
                  value={age}
                  onChange={(e) => {
                    setAge(e.target.value);
                  }}
                  className=" mt-2 text-gray-600 focus:outline-none focus:border focus:border-green-700 font-normal w-full h-10 flex items-center pl-3 text-sm border-gray-300 rounded border"
                  placeholder="Seleccionar"
                >
                  <option value="" hidden>
                    Seleccionar
                  </option>
                  <option value="Si">Sí</option>
                  <option value="No">No</option>
                </select>
              </div>
            </div>

            {age === "Si" ? (
              <div className="items-baseline">
                <div className="py-3">
                  <div>
                    <label
                      htmlFor="name"
                      className=" text-gray-800 text-sm font-bold leading-tight tracking-normal"
                    >
                      Nombre del Padre, Madre o apoderado legal
                    </label>
                    <input
                      id="name"
                      type="text"
                      onChange={handleChangeDataInput}
                      value={nombreApoderado}
                      maxLength="35"
                      name="nombreApoderado"
                      className={
                        nombreApoderado?.length === 0
                          ? " text-gray-600 focus:outline-none focus:border focus:border-green-700 font-normal w-full h-10 flex items-center pl-3 text-sm border-gray-300 rounded border"
                          : validarNombre(nombreApoderado) === "errorNombre"
                          ? "input__validation text-gray-600 focus:outline-none focus:border focus:border-green-700 font-normal w-full h-10 flex items-center pl-3 text-sm border-gray-300 rounded border"
                          : " text-gray-600 focus:outline-none focus:border focus:border-green-700 font-normal w-full h-10 flex items-center pl-3 text-sm border-gray-300 rounded border"
                      }
                      placeholder="Inserte su nombre por favor"
                    />
                  </div>
                  <div>
                    {nombreApoderado?.length === 0 ? null : validarNombre(
                        nombreApoderado
                      ) === "errorNombre" ? (
                      <p className="peer-invalid:visible text-red-700 font-light">
                        El Nombre del Padre, Madre o Apoderado legal sólo puede
                        contener letras, espacios y hasta 30 caracteres. Está
                        utilizando: {`${nombreApoderado?.length}`}
                      </p>
                    ) : null}
                  </div>
                </div>
                <div className="grid md:grid-cols-2 gap-4 items-baseline">
                  <div>
                    <div>
                      <label
                        htmlFor="name"
                        className="text-gray-800 text-sm font-bold leading-tight tracking-normal"
                      >
                        Teléfono/Celular
                      </label>
                      <input
                        id="name"
                        type="number"
                        onChange={handleChangeDataInput}
                        onWheel={(e) => e.target.blur()}
                        min="0"
                        value={
                          celularApoderado?.length > 12
                            ? celularApoderado.slice(0, 12).trim()
                            : celularApoderado
                        }
                        name="celularApoderado"
                        className={
                          celularApoderado?.length === 9 ||
                          celularApoderado?.length === 0
                            ? "mt-2 text-gray-600 focus:outline-none focus:border focus:border-green-700 font-normal w-full h-10 flex items-center pl-3 text-sm border-gray-300 rounded border"
                            : "input__validation  mt-2 text-gray-600 focus:outline-none focus:border focus:border-red-700 font-normal w-full h-10 flex items-center pl-3 text-sm border-gray-300 rounded border"
                        }
                        placeholder="Número Telefónico/Celular"
                        required={true}
                      ></input>
                    </div>
                    <div>
                      {celularApoderado?.length === 9 ||
                      celularApoderado?.length === 0 ? null : (
                        <p className="peer-invalid:visible text-red-700 font-light">
                          El N° celular debe tener 9 caracteres.
                        </p>
                      )}
                    </div>
                  </div>
                  <div>
                    <div>
                      <label
                        htmlFor="name"
                        className="text-gray-800 text-sm font-bold leading-tight tracking-normal"
                      >
                        Correo Electrónico
                      </label>
                      <input
                        id="name"
                        onChange={handleChangeDataInput}
                        value={correoApoderado}
                        name="correoApoderado"
                        type="email"
                        className={
                          correoApoderado?.length === 0
                            ? " mt-2 text-gray-600 focus:outline-none focus:border focus:border-green-700 font-normal w-full h-10 flex items-center pl-3 text-sm border-gray-300 rounded border"
                            : validarEmail(correoApoderado) === "errorEmail"
                            ? "input__validation mt-2 text-gray-600 focus:outline-none focus:border focus:border-red-700 font-normal w-full h-10 flex items-center pl-3 text-sm border-gray-300 rounded border"
                            : " mt-2 text-gray-600 focus:outline-none focus:border focus:border-green-700 font-normal w-full h-10 flex items-center pl-3 text-sm border-gray-300 rounded border"
                        }
                        placeholder="Ingrese Tipo de Documento"
                      />
                    </div>
                    <div>
                      {correoApoderado?.length === 0 ? null : validarEmail(
                          correoApoderado
                        ) === "errorEmail" ? (
                        <p className="peer-invalid:visible text-red-700 font-light">
                          El correo sólo puede contener letras, números, puntos,
                          guiones y guión bajo.
                        </p>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
            ) : null}
          </form>
        );

      case 1:
        return (
          <div>
            <div className="pt-3 md:grid grid-cols-2 gap-4  items-baseline">
              <div className="w-full grid">
                <FormControl>
                  <label
                    htmlFor="name"
                    className="pt-2 w-full text-gray-800 text-sm font-bold leading-tight tracking-normal"
                    name="bien"
                  >
                    Seleccione Tipo*
                  </label>
                  <div className="grid py-2 w-full justify-center">
                    <RadioGroup
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      onChange={handleChangeDataInput2}
                      value={bien2}
                      name="bien2"
                    >
                      <div className="pr-4">
                        <FormControlLabel
                          value="P"
                          control={<Radio size="small" />}
                          label="Producto"
                        />
                      </div>
                      <div>
                        <FormControlLabel
                          value="S"
                          control={<Radio size="small" />}
                          label="Servicio"
                        />
                      </div>
                    </RadioGroup>
                  </div>
                </FormControl>
              </div>
              <div className="mb-3 w-full pl-10 monto_ajuste">
                <label
                  htmlFor="name"
                  className="text-gray-800 text-sm font-bold leading-tight tracking-normal justify-end"
                >
                  Monto Reclamado en Soles S/.
                </label>
                <input
                  id="name"
                  onChange={handleChangeDataInput2}
                  value={monto2?.length > 8 ? monto2.slice(0, 8) : monto2}
                  name="monto2"
                  type="text"
                  onWheel={(e) => e.target.blur()}
                  className={
                    validarMonto(monto2) === "errorDominio"
                      ? "input__validation mt-2 text-gray-600 focus:outline-none focus:border focus:border-green-700 font-normal w-full h-10 flex items-baseline pl-3 text-sm border-gray-300 rounded border"
                      : "mt-2 text-gray-600 focus:outline-none focus:border focus:border-green-700 font-normal w-full h-10 flex items-center pl-3 text-sm border-gray-300 rounded border"
                  }
                  placeholder="Soles"
                />
                <div>
                  {validarMonto(monto2) === "aceptadoDominio" ? null : (
                    <p className="peer-invalid:visible text-red-700 font-light mt-2">
                      El monto sólo puede contener números positivos, punto y un
                      máximo de 8 caracteres (Tampoco se admite el caracter
                      "-").
                    </p>
                  )}
                </div>
              </div>
            </div>
            <div className="mb-4">
              <label
                htmlFor="name"
                className="text-gray-800 text-sm font-bold leading-tight tracking-normal"
              >
                Descripción*
              </label>
              <textarea
                maxLength="4005"
                id="name"
                onChange={handleChangeDataInput2}
                value={
                  descripcion2?.length > 4005
                    ? descripcion2.slice(0, 4005)
                    : descripcion2
                }
                name="descripcion2"
                className={
                  descripcion2?.length > 4000
                    ? "resize-none input__validation mt-2 text-gray-600 focus:outline-none focus:border focus:border-green-700 font-normal w-full h-32 flex items-center pl-3 text-sm border-gray-300 rounded border"
                    : "resize-none mt-2 text-gray-600 focus:outline-none focus:border focus:border-green-700 font-normal w-full h-32 flex items-center pl-3 text-sm border-gray-300 rounded border"
                }
                placeholder="4000 caracteres máximo"
              />
            </div>
            <div>
              {descripcion2?.length > 4000 ? (
                <p className="peer-invalid:visible text-red-700 font-light mt-2">
                  La Descripción sólo puede contener 4000 caracteres. Usted está
                  usando: {`${descripcion2?.length}`}
                </p>
              ) : null}
            </div>
            <div className="mb-4">
              <label
                htmlFor="name"
                className="text-gray-800 text-sm font-bold leading-tight tracking-normal"
                name="local"
              >
                Local*
              </label>
              <select
                id="name"
                onChange={handleChangeDataInput2}
                value={local2}
                name="local2"
                className="mt-2 text-gray-600 focus:outline-none focus:border focus:border-green-700 font-normal w-full h-10 flex items-center pl-3 text-sm border-gray-300 rounded border"
                required
              >
                <option value="" hidden>
                  Seleccionar
                </option>
                <option value="CU">CAMPUS UNIVERSITARIO</option>
                <option value="CE">CEPURP</option>
                <option value="CC">CENTRO CULTURAL CCORIWASI</option>
                <option value="CP">CENTRO DE ESPARCIMIENTO DEPORTIVO</option>
              </select>
            </div>
            <div className="mb-4">
              <label
                htmlFor="name"
                className="text-gray-800 text-sm font-bold leading-tight tracking-normal"
              >
                Nombre de la Unidad, Programa o Curso*
              </label>
              <input
                id="name"
                onChange={handleChangeDataInput2}
                value={
                  programa2?.length > 50 ? programa2.slice(0, 50) : programa2
                }
                name="programa2"
                className="mt-2 text-gray-600 focus:outline-none focus:border focus:border-green-700 font-normal w-full h-10 flex items-center pl-3 text-sm border-gray-300 rounded border"
                placeholder="Área de la URP"
              />
            </div>
          </div>
        );

      case 2:
        return (
          <div className="grid gap-2">
            <div className=" grid md:grid-cols-2 gap-4 items-between pb-2 pt-2">
              <div className="w-full">
                <div className="w-full grid">
                  <FormControl>
                    <label
                      htmlFor="name"
                      className="pt-2  text-gray-800 text-sm font-bold leading-tight tracking-normal"
                      name="bien"
                    >
                      Seleccione Tipo*
                    </label>
                    <div className="grid pt-3 w-full justify-center">
                      <RadioGroup
                        row
                        aria-labelledby="demo-row-radio-buttons-group-label"
                        onChange={handleChangeDataInput3}
                        value={reclamo3}
                        name="reclamo3"
                      >
                        <div className="pr-4">
                          <FormControlLabel
                            value="R"
                            control={<Radio size="small" />}
                            label="Reclamo "
                          />
                        </div>
                        <div>
                          <FormControlLabel
                            value="Q"
                            control={<Radio size="small" />}
                            label="Queja   "
                          />
                        </div>
                      </RadioGroup>
                    </div>
                  </FormControl>
                </div>
              </div>
              <div className="w-full">
                <label
                  htmlFor="name"
                  className="text-gray-800 text-sm font-bold leading-tight tracking-normal justify-end"
                >
                  Tipo de Reclamo o Queja*
                </label>
                <select
                  id="name"
                  onChange={handleChangeDataInput3}
                  value={queja3}
                  name="queja3"
                  className="mt-2 text-gray-600 focus:outline-none focus:border focus:border-green-700 font-normal w-full h-10 flex items-center pl-3 text-sm border-gray-300 rounded border"
                  placeholder="Primer Nombre"
                >
                  <option value="" hidden>
                    Seleciona el Tipo
                  </option>
                  <option value="IN">Infraestructura</option>
                  <option value="CP">
                    Características del Producto o Servicio
                  </option>
                  <option value="TP">Trato del Personal</option>
                  <option value="OR">Otro Reclamo</option>
                </select>
              </div>
            </div>
            <div>
              <label
                htmlFor="name"
                className="text-gray-800 text-sm font-bold leading-tight tracking-normal"
              >
                Detalle*
              </label>
              <textarea
                maxLength="4005"
                id="name"
                onChange={handleChangeDataInput3}
                value={
                  detalle3?.length > 4005 ? detalle3.slice(0, 4005) : detalle3
                }
                name="detalle3"
                className={
                  detalle3?.length > 4000
                    ? "resize-none input__validation mt-2 text-gray-600 focus:outline-none focus:border focus:border-green-700 font-normal w-full h-32 flex items-center pl-3 text-sm border-gray-300 rounded border"
                    : "resize-none mt-2 text-gray-600 focus:outline-none focus:border focus:border-green-700 font-normal w-full h-32 flex items-center pl-3 text-sm border-gray-300 rounded border"
                }
                placeholder="Describa el problema generado. 4000 caracteres como máximo"
              />
            </div>
            <div>
              {detalle3?.length > 4000 ? (
                <p className="peer-invalid:visible text-red-700 font-light mt-2">
                  El detalle sólo puede contener 4000 caracteres. Usted está
                  usando: {`${detalle3?.length}`}
                </p>
              ) : null}
            </div>
            <div className="pt-1">
              <label
                htmlFor="name"
                className="text-gray-800 text-sm font-bold leading-tight tracking-normal"
              >
                Pedido*
              </label>
              <textarea
                maxLength="4005"
                id="name"
                onChange={handleChangeDataInput3}
                value={
                  pedido3?.length > 4005 ? pedido3.slice(0, 4005) : pedido3
                }
                name="pedido3"
                className={
                  pedido3?.length > 4000
                    ? "resize-none input__validation mt-2 text-gray-600 focus:outline-none focus:border focus:border-green-700 font-normal w-full h-32 flex items-center pl-3 text-sm border-gray-300 rounded border"
                    : "resize-none mt-2 text-gray-600 focus:outline-none focus:border focus:border-green-700 font-normal w-full h-32 flex items-center pl-3 text-sm border-gray-300 rounded border"
                }
                placeholder="Informe su Solicitud. 4000 caracteres como máximo "
              />
            </div>
            <div>
              {pedido3?.length > 4000 ? (
                <p className="peer-invalid:visible text-red-700 font-light mt-2">
                  El pedido sólo puede contener 4000 caracteres. Usted está
                  usando: {`${pedido3?.length}`}
                </p>
              ) : null}
            </div>
          </div>
        );

      default:
        <></>;
    }
  };

  return (
    <div>
      <div>
        <div className=" container my-2 mx-auto w-11/12 md:w-5/6 max-w-4xl">
          <div className="px-8 py-7 flex justify-between items-center w-full bg-green-700  rounded-t-md border border-gray-400 flex-col md:flex-row gap-4 ">
            <div className="w-full flex  justify-center md:justify-start">
              <img className="img_logo" src={`./${logoURPBLANCO}`} />
            </div>
            <div className="w-full text-center">
              <h1 className="mb-3 font-bold text-white text-xl">
                Libro de reclamaciones
              </h1>
              <p className="text-white texto_p">
                Conforme a lo establecido en el Código de Protección y Defensa
                del Consumidor esta institución cuenta con un Libro de
                Reclamaciones a tu disposición
              </p>
            </div>
          </div>
          <div className="px-8 py-7 flex items-center w-full bg-white rounded-b-md border-gray-400  group_ruc gap-4 ">
            <div className="w-full ">
              <p className="text-black texto_p--two">
                Universidad RICARDO PALMA
              </p>
              <p className="text-black texto_p--two">R.U.C. 20147883952</p>
            </div>
            <div className="w-full text-right">
              <p className="text-black texto_p--two">
                Av Benavides 5440 Santiago de Surco
              </p>
              <p className="text-black texto_p--two">Lima 33 Perú</p>
            </div>
          </div>

          <div className="relative my-2 py-8 px-10 bg-white shadow-md rounded border border-gray-400">
            <Tabs>
              <TabList>
                <Tab>Reclamo</Tab>
                <Tab>Seguimiento</Tab>
              </TabList>
              <TabPanel>
                <div className="pt-1 flex justify-between gap-4 items-end">
                  <div>
                    <label
                      htmlFor="name"
                      className=" text-gray-800 text-sm font-bold leading-tight tracking-normal"
                    >
                      Fecha
                    </label>
                    <input
                      type="date"
                      id="name"
                      value={fechaActual}
                      disabled
                      className="mb-2 mt-2 text-gray-600 focus:outline-none focus:border focus:border-green-700 font-normal w-full h-10 flex items-center pl-9 text-sm border-gray-300 rounded border" //pl-10
                    />
                  </div>
                </div>
                <Box sx={{ width: "100%" }}>
                  <Stepper
                    activeStep={activeStep}
                    sx={{ overflowY: "auto", py: 2 }}
                  >
                    {steps.map((label, index) => {
                      const stepProps = {};
                      const labelProps = {};
                      return (
                        <Step key={label} {...stepProps}>
                          <StepLabel {...labelProps}>{label}</StepLabel>
                        </Step>
                      );
                    })}
                  </Stepper>

                  {activeStep === steps?.length ? (
                    <React.Fragment>
                      <div className="grid grid-cols-12 gap-2 mt-8">
                        <div className="flex col-start-5 justify-center">
                          <input
                            type="checkbox"
                            id="miElementoCheckbox"
                            checked={checkboxConditional}
                            size={"1"}
                            style={{
                              width: "18px",
                            }}
                            onClick={() =>
                              setCheckboxConditional(!checkboxConditional)
                            }
                          ></input>
                        </div>
                        <div className="col-span-6">
                          <p className="text-[13px]">
                            Acepto las
                            <span
                              className="text-lime-700 font-bold hover:text-lime-600 hover:cursor-pointer"
                              onClick={() =>
                                window.open(
                                  "https://www.urp.edu.pe/politica-de-privacidad/",
                                  "_blank",
                                  "noopener"
                                )
                              }
                              // onClick={() => setOpenModal(true)}
                            >
                              {" "}
                              Políticas de Privacidad
                            </span>
                          </p>
                        </div>
                      </div>
                      <Box
                        sx={{ display: "flex", flexDirection: "row", pt: 2 }}
                      >
                        <Box sx={{ flex: "1 1 auto" }} />
                        {sendValidation ? null : (
                          <Button
                            disabled={
                              load
                                ? true
                                : false || checkboxConditional
                                ? false
                                : true
                            }
                            variant="contained"
                            onClick={() => {
                              sendData();
                              setLoad(true);
                            }}
                            sx={{
                              backgroundColor: "#198540",
                              ":hover": {
                                backgroundColor: "#9ecbae",
                              },
                            }}
                          >
                            {load ? (
                              <div className="lds-ring">
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                              </div>
                            ) : null}
                            {load ? "Enviando..." : "Enviar"}
                          </Button>
                        )}
                      </Box>
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      {getContent(activeStep)}
                      <Box
                        sx={{ display: "flex", flexDirection: "row", pt: 2 }}
                      >
                        <Button
                          color="inherit"
                          disabled={activeStep === 0}
                          onClick={handleBack}
                          sx={{ mr: 1 }}
                        >
                          Retroceder
                        </Button>
                        <Box sx={{ flex: "1 1 auto" }} />
                        <Button
                          disabled={
                            (activeStep === 0 && validationStep01) ||
                            (activeStep === 1 && validationStep02) ||
                            (activeStep === 2 && validationStep03)
                          }
                          variant="contained"
                          type="submit"
                          onClick={handleOnsubmit}
                          sx={{
                            backgroundColor: "#198540",
                            ":hover": {
                              backgroundColor: "#9ecbae",
                            },
                          }}
                        >
                          {activeStep === steps?.length - 1
                            ? "Terminado"
                            : "Siguiente"}
                        </Button>
                      </Box>
                    </React.Fragment>
                  )}
                  <div
                    className={
                      activeStep === 3
                        ? "hidden"
                        : "grid grid-cols-12 gap-2 mt-8 "
                    }
                  >
                    <div className="flex col-start-5 justify-center">
                      <input
                        type="checkbox"
                        id="miElementoCheckbox"
                        checked={checkboxConditional}
                        size={"1"}
                        style={{
                          width: "18px",
                        }}
                        onClick={() =>
                          setCheckboxConditional(!checkboxConditional)
                        }
                      ></input>
                    </div>
                    <div className="col-span-6">
                      <p className="text-[13px]">
                        Acepto las
                        <span
                          className="text-lime-700 font-bold hover:text-lime-600 hover:cursor-pointer"
                          onClick={() =>
                            window.open(
                              "https://www.urp.edu.pe/politica-de-privacidad/",
                              "_blank",
                              "noopener"
                            )
                          }
                          // onClick={() => setOpenModal(true)}
                        >
                          {" "}
                          Políticas de Privacidad
                        </span>
                      </p>
                    </div>
                  </div>
                </Box>
              </TabPanel>
              <TabPanel>
                <div>
                  <div>
                    <label
                      htmlFor="name"
                      className="text-gray-800 text-sm font-bold leading-tight tracking-normal"
                    >
                      Inserte su Número de Reclamo:
                    </label>
                    <input
                      id="name"
                      value={reclamo}
                      onChange={(e) => setReclamo(e.target.value)}
                      className="mb-5 mt-2 text-gray-600 focus:outline-none focus:border focus:border-green-700 font-normal w-full h-10 flex items-center pl-3 text-sm border-gray-300 rounded border"
                      placeholder="Nro adjuntado a su correo, luego de enviar el Reclamo"
                    />
                    <button
                      type="button"
                      onClick={() => busqueda()}
                      className=" my-2 bg-green-700 text-white transition duration-150 ease-in-out focus:outline-none rounded  border border-gray-300 px-6 py-2 text-xs" //text-gray-800
                    >
                      BUSCAR RECLAMO
                    </button>
                  </div>
                  <h1 className="py-3 text-gray-800 font-lg font-bold tracking-normal leading-tight mb-4">
                    4. Acciones adoptadas por el proveedor
                  </h1>
                  <div>
                    <label
                      htmlFor="name"
                      className="text-gray-800 text-sm font-bold leading-tight tracking-normal"
                    >
                      Fecha
                    </label>
                    <input
                      id="name"
                      type="text"
                      value={saveData[0]?.fecha || ""}
                      disabled
                      className="mb-5 mt-2 text-gray-600 focus:outline-none focus:border focus:border-green-700 font-normal w-full h-10 flex items-center pl-3 text-sm border-gray-300 rounded border"
                      placeholder="Día/Mes/Año"
                    ></input>
                  </div>
                  <div>
                    <label
                      htmlFor="name"
                      className="text-gray-800 text-sm font-bold leading-tight tracking-normal"
                    >
                      Respuesta
                    </label>
                    <textarea
                      value={saveData[0]?.CLIRE_RESPUESTA || ""}
                      disabled
                      id="name"
                      className="mb-5 mt-2 text-gray-600 focus:outline-none focus:border focus:border-green-700 font-normal w-full h-48 flex items-center pl-3 text-sm border-gray-300 rounded border"
                      placeholder="4000 Caracteres como máximo"
                    ></textarea>
                  </div>
                </div>
              </TabPanel>
            </Tabs>
          </div>
        </div>
      </div>
      {openModal ? (
        <ModalTerminos openModal={openModal} setOpenModal={setOpenModal} />
      ) : null}
      {setOpenValid ? (
        <ModalValidation openValid={openValid} setOpenValid={setOpenValid} />
      ) : null}
      <ToastContainer />
    </div>
  );
};
export default Form;
